import { usePostMessageListener } from '@/hooks/usePostMessageListener';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback } from 'react';

export enum PowerAppsTriggerEventNames {
  PROPERTY_UPDATE = 'propertyUpdate',
  FORM_SUBMITTED = 'formSubmitted',
}

const postMessageConnection = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

export const usePowerAppsTrigger = (onTrigger: (data: any) => void) => {
  const handleRefreshParentMessage = useCallback(
    (props: any) => {
      const data = postMessageConnection(props);
      if (!data) return;

      if (/trigger/.test(data?.event)) onTrigger(data?.data);
    },
    [onTrigger],
  );

  usePostMessageListener(handleRefreshParentMessage);
};
